import { render, staticRenderFns } from "./StudentUpload.vue?vue&type=template&id=f3042408&scoped=true&"
import script from "./StudentUpload.vue?vue&type=script&lang=js&"
export * from "./StudentUpload.vue?vue&type=script&lang=js&"
import style0 from "./StudentUpload.vue?vue&type=style&index=0&id=f3042408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3042408",
  null
  
)

export default component.exports